var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"tabs",on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"视频","name":"first"}},[_c('v-video')],1),_c('el-tab-pane',{attrs:{"label":"音频","name":"second"}},[_c('v-radio')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }